import React, { CSSProperties, FC, memo } from "react";
import { useDrop } from "react-dnd";
import ReactHtmlParser from "react-html-parser";
import { CrossSVG } from "../../assets/svgs";
import Latex from "../latex";
import { ItemTypes } from "../MatrixSortItem";

const style: CSSProperties = {};

export interface DropAreaProps {
  onDrop: (item: any) => void;
  onCross: () => void;
  _userInput: string;
  disabled: boolean;
}

export const DropArea: FC<DropAreaProps> = memo(function DropArea({
  onDrop,
  onCross,
  _userInput,
  disabled,
}) {
  const [{ isOver, canDrop }, drop] = useDrop({
    accept: ItemTypes.BOX,
    drop: onDrop,
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  });

  const isActive = isOver && canDrop && !_userInput;
  const isDone = _userInput;

  let backgroundColor = "transparent";
  if (isActive) {
    backgroundColor = "#fde9b8";
  } else if (canDrop && !_userInput) {
    backgroundColor = "#fff4d9";
  }

  return disabled ? (
    <div ref={drop} style={{ ...style, backgroundColor }} className="drop_item">
      <div className="drop_item_inner">
        <div className="drop_box_item disabled_drop_item">
          <Latex> {ReactHtmlParser(_userInput)}</Latex>
        </div>
      </div>
    </div>
  ) : (
    <div ref={drop} style={{ ...style, backgroundColor }} className="drop_item">
      <div className="drop_item_inner">
        {isActive ? (
          "Release to drop"
        ) : isDone ? (
          <div className="drop_box_item">
            <Latex>{ReactHtmlParser(_userInput)}</Latex>
            <span className="drag_placeholder left_side"></span>
            <span className="drag_placeholder right_side"></span>
            {_userInput ? (
              <button onClick={onCross} type="button" className="removeClose">
                <CrossSVG />
              </button>
            ) : null}
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
});
